import { defineStore } from 'pinia';

export const useTipsStore = defineStore('tips', {
  state: (): { isOffered: boolean | null; isTipSent: boolean } => ({
    isOffered: null,
    isTipSent: false,
  }),
});
